import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { EXPERIMENT_VIEWED } from '../../constants/analytics-events';
import { ExperimentGroupVariations } from '../experiment/experiments';
import Global from '../../store/global-selectors';
import { Segment } from '../../services/analytics-services/segment';
import { useFeatureFlag } from '../../feature-flags/hooks/use-feature-flag';
import { FeatureFlagDeclarations } from '../../feature-flags/feature-flag-declarations';

const GROW_731 = 'GROW_731';

export const useTrackGrow731Experiment = () => {
  const shouldHideInfoModal = useFeatureFlag(FeatureFlagDeclarations.enableByoAbTesting);
  const variant = shouldHideInfoModal ? ExperimentGroupVariations.VARIANT : ExperimentGroupVariations.CONTROL;
  const sellerId = useSelector(Global.selectSellerSellerId)?.toString();
  const userId = useSelector(Global.selectUserCurrentUserId);

  return useCallback(async () => {
    Segment.trackEvent(EXPERIMENT_VIEWED, {
      experiment_id: GROW_731,
      group_variation: variant,
      seller_id: sellerId,
      user_id: userId,
      enrollment_date: new Date(),
    });
  }, [sellerId, userId, variant]);
};
